import styled from "@emotion/styled";

export const ReplacementReasonBoxContainer = styled.div(({ theme }) => ({
	border: `1px solid ${theme.project.colors.allColors.hex.grayscale.gray300}`,
	width: "100%"
}));
